/**
 * This file defines constants and type aliases for shapes used in the engine.
 * It centralizes the logic for shape identification and aliasing.
 */

export const SHAPE_ALIASES: { [key: string]: string[] } = {
    box: ['box', 'cube'],
    roundedBox: ['roundedbox'],
    quader: ['quader'],
    tile: ['tile'],
    plane: ['plane', 'quad'],
    multiplane: ['multiplane', 'multiplanes'],
    triangle: ['triangle'],
    sphere: ['sphere'],
    torus: ['torus'],
    gltf: ['gltf', 'glb'],
    usdz: ['usdz'],
    youtube: ['youtube', 'yt'],
    none: ['none', 'empty', 'null', 'void']
};

/**
 * Finds the canonical name for a given shape name, checking against aliases.
 * @param shapeName The shape name to check (e.g., "tile").
 * @returns The canonical shape name (e.g., "box") or the original name if no alias is found.
 */
export function getCanonicalShapeName(shapeName: string): string {
    const lowerShapeName = shapeName.toLowerCase();
    for (const canonicalName in SHAPE_ALIASES) {
        if (SHAPE_ALIASES[canonicalName].includes(lowerShapeName)) {
            return canonicalName;
        }
    }
    return lowerShapeName;
} 